import { RighArrow, LeftArrow } from './../components/Arrows';
import React from 'react'

const listing_web = (object_name, custom_tag, orientation) => {
  let settings = {
    horizontal: {
      speed: 400,
      slidesToShow: 4,
      slidesToScroll: 0,
      adaptiveHeight: true,
      initialSlide: 0,
      infinite: false,
      arrows: false,
      dots: false,
    },
    vertical: {
      vertical: true,
      verticalSwiping: true,
      infinite: true,
      speed: 500,
      arrows: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      initialSlide: 0,
      nextArrow: <RighArrow object_name={object_name} custom_tag={custom_tag}/>,
      prevArrow: <LeftArrow object_name={object_name} custom_tag={custom_tag}/>,
    }
  }
  return settings[orientation]
}

export { listing_web }


// WEBPACK FOOTER //
// ./src/node_modules/components/Pimper/WebCarousel/settings/listing_web.js